import { render, staticRenderFns } from "./CmgAccountModalAccountLinks.vue?vue&type=template&id=40ef13ff&scoped=true&lang=pug"
import script from "./cmg-account-modal-account-links.ts?vue&type=script&lang=ts&external"
export * from "./cmg-account-modal-account-links.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAccountModalAccountLinks.vue?vue&type=style&index=0&id=40ef13ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef13ff",
  null
  
)

export default component.exports